import React from 'react';
import useVersionCheck from '../hooks/useVersionCheck';

// Root-mounted bar that appears (pinned bottom) once the version poll detects a
// new deploy. The Reload button does a full window reload so fresh assets load.
const UpdateBanner = () => {
  const updateAvailable = useVersionCheck();
  if (!updateAvailable) return null;

  return (
    <div
      role="status"
      style={{
        position: 'fixed',
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 16,
        flexWrap: 'wrap',
        padding: '12px 20px',
        background: 'var(--ink, #1A1A1A)',
        color: '#fff',
        fontFamily: 'var(--font-ui)',
        fontSize: 14,
        boxShadow: '0 -2px 12px rgba(0,0,0,0.25)',
      }}
    >
      <span>A new version is available - please reload to get the latest update.</span>
      <button
        type="button"
        onClick={() => window.location.reload()}
        style={{
          background: 'var(--orange, #E36D2C)',
          color: '#fff',
          border: 'none',
          borderRadius: 6,
          padding: '6px 16px',
          fontFamily: 'var(--font-ui)',
          fontSize: 14,
          fontWeight: 600,
          cursor: 'pointer',
        }}
      >
        Reload now
      </button>
    </div>
  );
};

export default UpdateBanner;
